import React, { Component } from "react";
import { Query } from "react-apollo";
import debounce from "lodash/debounce";
import {
  LabeledTextBox,
  PictureUpload,
  CheckBox,
  Theme,
} from "../../../globalComponents";
import SelectAddress from "../../../globalComponents/FormComponents/selectAddress";
import SelectDashBoardMember from "../../../globalComponents/FormComponents/selectDashboardMember";
import { PARK_NAMES } from "../../../store/queries";
import { placeAutoComplete, placeDetails } from "../../../utils/placeapis";
import { USER_UPDATE_INFO, USER_UPDATE_ADDRESS } from "../../../store/mutations";

class OwnerInfo extends Component {
  state = {
    suggestions: [],
    selectedAddress: "",
    saving: false,
    saveError: null,
  };

  // Debounced save for owner info (firstName, lastName, email, phoneNumber, profilePicture)
  saveOwnerInfo = debounce(async (includeProfilePicture = false) => {
    const { client, userId, getFormValues } = this.props;
    if (!client || !userId) return;

    const values = getFormValues();
    if (!values) return;

    this.setState({ saving: true, saveError: null });

    try {
      const ownerInfo = {
        firstName: values.firstName,
        lastName: values.lastName,
        phoneNumber: values.phoneNumber,
        email: values.email,
        id: parseInt(userId),
      };

      // Include profile picture only if it's a new upload (valid signed ID)
      if (includeProfilePicture && values.profilePicture) {
        if (typeof values.profilePicture === 'string' && values.profilePicture.startsWith('eyJ')) {
          // Valid signed ID from new upload
          ownerInfo.profilePicture = values.profilePicture;
        } else if (values.profilePicture.url) {
          // Existing profile picture object - don't include it
          console.log('[OwnerInfo] Skipping profilePicture - existing profile picture object');
        } else if (typeof values.profilePicture === 'string' && values.profilePicture.startsWith('/rails/')) {
          // Blob redirect URL - don't include it
          console.log('[OwnerInfo] Skipping profilePicture - blob redirect URL detected');
        }
      }

      await client.mutate({
        mutation: USER_UPDATE_INFO,
        variables: { input: ownerInfo },
      });

      this.setState({ saving: false });
      console.log("Owner info auto-saved successfully");
    } catch (error) {
      console.error("Auto-save owner info error:", error);
      this.setState({ saving: false, saveError: error.message });
    }
  }, 1000);

  // Debounced save for address info
  saveAddressInfo = debounce(async () => {
    const { client, userId, getFormValues } = this.props;
    if (!client || !userId) return;

    const values = getFormValues();
    if (!values) return;

    this.setState({ saving: true, saveError: null });

    try {
      const addressInfo = {
        address: values.address,
        address2: values.address2,
        city: values.city,
        state: values.state,
        zip: values.zip,
        id: parseInt(userId),
      };

      await client.mutate({
        mutation: USER_UPDATE_ADDRESS,
        variables: { input: addressInfo },
      });

      this.setState({ saving: false });
      console.log("Address info auto-saved successfully");
    } catch (error) {
      console.error("Auto-save address error:", error);
      this.setState({ saving: false, saveError: error.message });
    }
  }, 1000);

  componentWillUnmount() {
    // Cancel any pending debounced saves
    this.saveOwnerInfo.cancel();
    this.saveAddressInfo.cancel();
  }

  // componentDidMount() {
  //     this.props.change("tagName", "Static Tag")

  // }
  getAddressSuggestion = async (e) => {
    let payload = {
      input: e.target.value,
      radius: "100",
    };
    let suggest = await placeAutoComplete(payload);
    this.setState({
      suggestions: suggest,
    });
  };

  handleSelecteAddress = async (address) => {
    let place_id = address.place_id;
    let payload = {
      place_id,
    };
    let getAddress = await placeDetails(payload);
    getAddress.address_components.map((item) => {
      switch (item.types[0]) {
        case "country":
          this.props.change("address", getAddress.name);
          this.setState({
            selectedAddress: getAddress.name,
          });
          break;
        case "postal_code":
          this.props.change("zip", item.long_name);
          break;
        case "administrative_area_level_1":
          this.props.change("state", item.short_name);
          break;
        case "locality":
          this.props.change("city", item.long_name);
          break;
        default:
      }
    });
    // Auto-save address after selection (with small delay for form state to update)
    setTimeout(() => this.saveAddressInfo(), 100);
  };
  render() {
    const { stateAbbreviations, userData, change, global, role } = this.props;
    const obj = global || { dimensions: { height: 0, width: 1000 } };
    const height = obj.dimensions.height;
    const width = obj.dimensions.width;
    const shrink = width < 768;
    const { suggestions, selectedAddress, saving, saveError } = this.state;
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: shrink ? "100%" : "50%",
        }}
      >
        <div
          style={{
            marginBottom: "2%",
            marginTop: "5%",
            textAlign: shrink ? "center" : "",
            fontFamily: Theme.HEADER_FONT,
            fontSize: Theme.getHeaderFont(width),
            color: Theme.HEADER_FONT_COLOR,
            display: "flex",
            alignItems: "center",
            justifyContent: shrink ? "center" : "flex-start",
          }}
        >
          Pet Owner Info
          {saving && (
            <span style={{
              marginLeft: "10px",
              fontSize: "12px",
              color: "#888",
              fontFamily: Theme.MAIN_FONT
            }}>
              Saving...
            </span>
          )}
          {saveError && (
            <span style={{
              marginLeft: "10px",
              fontSize: "12px",
              color: "red",
              fontFamily: Theme.MAIN_FONT
            }}>
              Save failed
            </span>
          )}
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
          }}
        >
          <PictureUpload
            width={width}
            containerStyle={{ marginRight: "10px" }}
            picture={this.props.getPicture()}
            name="profilePicture"
            onUpload={(v, pic) => {
              change("profilePicture", v);
              this.props.setState(pic);
              // Auto-save profile picture after upload (with delay for form state to update)
              setTimeout(() => this.saveOwnerInfo(true), 100);
            }}
            height={height}
            label="Picture"
          />
          <div
            style={{
              display: "flex",
              marginTop: "2%",
              flexDirection: "column",
              width: "calc(100% - 150px)",
            }}
          >
            {/* <ParlorForm /> */}
            <LabeledTextBox
              name="firstName"
              onBlur={() => this.saveOwnerInfo()}
              width={width}
              widthpercent={"100%"}
              height={height}
              label="First Name"
            />
            <LabeledTextBox
              name="lastName"
              onBlur={() => this.saveOwnerInfo()}
              width={width}
              widthpercent={"100%"}
              height={height}
              label="Last Name"
            />
            <div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div
                  style={{
                    color: Theme.DARK_TEXT_COLOR,
                    fontSize: Theme.getNormalFont(width),
                    fontFamily: Theme.MAIN_FONT,
                  }}
                >
                  <span>Home Park</span>
                </div>

                <Query fetchPolicy="no-cache" query={PARK_NAMES}>
                  {({ loading, error, data, refetch }) => {
                    if (error) return `Error: ${error.message}`;
                    return (
                      <SelectDashBoardMember
                        alt={true}
                        options={data?.restrictedFetchParks}
                        handleSelect={(park, name) => {
                          this.props.change(name, park.id);
                          // this.props.change("parkId", park.name);
                          this.props.setStatePark(park.name);
                          this.props.handleParkName(park.id, park.name);
                        }}
                        selected={
                          this.props.parkName || userData.userDetail.park?.name
                        }
                        name="parkId"
                        width={"100%"}
                        height={height / 25}
                        label="Park Location"
                      />
                    );
                  }}
                </Query>
              </div>
            </div>
            {/* <CheckBox
              name="acceptsSms"
              containerStyle={{ width: "100%", marginTop: "5%" }}
              width={width}
              label="Accepts text updates and specials?"
            /> */}
          </div>
        </div>
        {
          <LabeledTextBox
            name="tagName"
            onBlur={() => { }}
            width={width}
            widthpercent={"100%"}
            height={height}
            label="Tag"
            onClick={(e) => e.preventDefault()}
            onChange={(e) => e.preventDefault()}
          />
        }

        <div
          style={{
            marginBottom: "2%",
            marginTop: "10%",
            fontFamily: Theme.HEADER_FONT,
            fontSize: Theme.getHeaderFont(width),
            color: Theme.HEADER_FONT_COLOR,
          }}
        >
          Member Address
        </div>
        {/* <LabeledTextBox
                    name="address"
                    onBlur={() => { }}
                    width={width}
                    widthpercent={"100%"}
                    height={height}
                    label="Address"
                    // onChange={(e) => this.getAddressSuggestion(e)}
                    options={suggestions}
                /> */}

        <SelectAddress
          alt={true}
          options={suggestions}
          handleSelect={(address, name) => {
            this.handleSelecteAddress(address);
          }}
          selected={selectedAddress}
          name="address"
          width={width}
          height={height}
          widthpercent={"100%"}
          label="Address"
          getAddressSuggestion={this.getAddressSuggestion}
        />
        <LabeledTextBox
          name="address2"
          onBlur={() => this.saveAddressInfo()}
          width={width}
          widthpercent={"100%"}
          height={height}
          label="Address Line 2"
        />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          <div style={{ width: "50%" }}>
            <LabeledTextBox
              name="city"
              onBlur={() => this.saveAddressInfo()}
              widthpercent={"100%"}
              width={width}
              height={height}
              label="City"
            />
          </div>
          <div style={{ width: "20%" }}>
            <LabeledTextBox
              name="state"
              widthpercent={"100%"}
              options={stateAbbreviations}
              // validate={["required"]}
              width={width}
              height={height}
              label="State"
              onBlur={() => this.saveAddressInfo()}
            />
          </div>
          <div style={{ width: "20%" }}>
            <LabeledTextBox
              name="zip"
              onBlur={() => this.saveAddressInfo()}
              widthpercent={"100%"}
              width={width}
              height={height}
              label="Zipcode"
            />
          </div>
        </div>
        <LabeledTextBox
          name="email"
          onBlur={() => this.saveOwnerInfo()}
          width={width}
          widthpercent={"100%"}
          height={height}
          label="Email"
        />
        <LabeledTextBox
          name="phoneNumber"
          onBlur={() => this.saveOwnerInfo()}
          width={width}
          widthpercent={"100%"}
          height={height}
          validate={["required", "number"]}
          label="Mobile Number"
        />
      </div>
    );
  }
}

export default OwnerInfo;
